import { Stack } from "@mui/material";
import MyBreathingRateScreen from ".";
import type { BreathingRateDataPoint } from "./BreathingRateChart";
import { WellnessScoreStatus } from "../../Common/types";

const sampleChartData: BreathingRateDataPoint[] = [
  { date: "20/01", breathingRate: 15, fullDate: "20.01.2025" },
  { date: "02/04", breathingRate: 14, fullDate: "02.04.2025" },
  { date: "04/04", breathingRate: 16, fullDate: "04.04.2025" },
  { date: "12/05", breathingRate: 15, fullDate: "12.05.2025" },
  {
    date: "20/08",
    breathingRate: 14,
    fullDate: "20.08.2025",
    isSelected: true,
  },
];

export default function MyBreathingRateScreenExamples() {
  return (
    <Stack gap={4} width="100%">
      <MyBreathingRateScreen
        metricValue="14"
        status={WellnessScoreStatus.Healthy}
        lastUpdated="2025-08-20T00:00:00Z"
        chartData={sampleChartData}
      />
    </Stack>
  );
}
